"use client"
import css from "@css/modules/HottestDeals.module.scss"
import { FAQ } from "@t/FAQ"
import { useState } from "react"
import cn from "classnames"
import { CKEditor } from "@components/CKEditor"
import { QuestionIco } from "@css/icons/QuestionIco"
import { ArrowRight } from "@css/icons/ArrowRight"
import { Popover } from "antd"

type Props = {
    faqs: FAQ[]
}

export function DealsFAQ({ faqs }: Props) {
    const [active, setActive] = useState(-1)
    if (!faqs?.length) return null
    const content = (
        <div className={css.faqContent}>
            <h2>
                Frequently Asked Questions <QuestionIco />
            </h2>
            <ul className={css.faqList}>
                {faqs.map((faq, i) => {
                    return <FaqListItem key={i} active={active === i} {...faq} onClick={() => setActive((s) => (s === i ? -1 : i))} />
                })}
            </ul>
        </div>
    )
    return (
        <div className={css.faqRoot}>
            {content}
            <Popover overlayClassName={css.faqPopover} color="#423072" content={content} placement="top" trigger="click">
                <button className={css.faqButton}>FAQ</button>
            </Popover>
        </div>
    )
}

type FaqListItemProps = {
    active: boolean
    onClick?: () => void
} & FAQ

function FaqListItem({ onClick, active, question, answer }: FaqListItemProps) {
    return (
        <li className={cn(active && css.listItemActive)} onClick={onClick}>
            <div className={css.listItemTitle}>
                {question}
                <ArrowRight />
            </div>
            <CKEditor content={answer} className={css.faqDescription} />
        </li>
    )
}
